export default __webpack_public_path__ + "static/media/icon_pen.80e8b41f.svg";